import { selectChangeMessageForLinks } from '@UI/aside/asideLinks/asideLinksSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { loadWebConfigurations } from '@newStore/documentApi/documentApiState';
import { selectTitleWithDescriptionNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { NodeType, RequiredType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { shortDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { webSitesWwwHref } from '@store/api/apiRoutes';
import constants from '../../../reduxLoop/constants/constants';
import { settings } from '../../settings';
import {
  wwwDefaultBuildingBlocks,
  wwwOmslagAndTegelFotoComps,
  wwwTitleAndDescriptionComps,
} from './wwwGenericConfigProps';

export const WWW: RootNodeConfig = {
  nodeSelector: selectTitleWithDescriptionNode,
  validationRules: [],
  information: {
    definiteArticle: true,
    single: 'WWW.-inhoud',
    plural: 'WWW.-inhoud',
    icon: require('../../../../img/icons/webpage.svg'),
    category: 'WWW',
  },
  onLoadActions: [loadWebConfigurations()],
  createModal: {
    theme: {
      filter: {
        root: '085bc39d-c7a6-4209-bc7d-22962d23724b',
        typeIn: ContentType.THEME,
      },
    },
    authors: {
      addUser: true,
      required: true,
    },
    importDocx: {},
  },
  buildingBlocks: wwwDefaultBuildingBlocks,
  referenceGroupTypes: [
    constants.referenceGroupTypes.WWW_NEWS_ITEM,
    constants.referenceGroupTypes.WWW_CURRENT_THEME,
  ],
  tocTypes: [NodeType.SECTION],
  edit: [
    ...wwwTitleAndDescriptionComps,
    shortDescriptionComponent,
    // {
    //   ...imageComponentBase,
    //   width: 6,
    //   label: 'Omslagfoto',
    //   options: {
    //     type: 'COVER_IMAGE',
    //     crop: {}, // Crop without enforced aspectRatio
    //     fields: [],
    //   },
    // },
    ...wwwOmslagAndTegelFotoComps,
    {
      ...authorsComponent,
      required: RequiredType.ERROR,
    },
    publishComponent,
    {
      component: 'linkGroup',
      reactComponent: 'AsideLinks',
      asideChangeMessageSelector: selectChangeMessageForLinks,

      label: 'Gerelateerd thema on PRO',
      options: {
        type: 'group',
        modalTitle: 'Gerelateerd thema on PRO invoegen',
      },
      hiddenChildren: {
        containerType: ContentType.LINK_GROUP,
        items: [
          {
            type: ContentType.REFERENCE,
            label: 'link',
          },
        ],
      },
    },
  ],
  webTab: asideWebBasicConfiguration,
  customEditorOptions: {
    hideTermButton: true,
  },
  isCreatable: true,
  isSearchable: true,
  isImportable: true,
  allowSuggestions: false,
  websiteEdition: [
    {
      domain: settings.domains.www,
    },
  ],
  websiteHref: webSitesWwwHref,
};
